import { render, staticRenderFns } from "./AiTextGenerationModal.vue?vue&type=template&id=48c71534&scoped=true"
import script from "./AiTextGenerationModal.vue?vue&type=script&lang=js"
export * from "./AiTextGenerationModal.vue?vue&type=script&lang=js"
import style0 from "./AiTextGenerationModal.vue?vue&type=style&index=0&id=48c71534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c71534",
  null
  
)

export default component.exports